<template>
    <div>
        <div class="page-title">
            <h4> Calendar Service </h4>
        </div>
        <div class="calendar-wrapper">
            <div class="calendar-filter-section">
                <div class="calendar-first-filter">
                    <v-select placeholder="Alege Anul"
                          v-model="filters.year"
                          :options='years'
                          @change="filterCalendar()"
                          label='name'>
                    </v-select>
                    <v-select placeholder="Alege Luna"
                          v-model="filters.month"
                          :options="months"
                          @change="filterCalendar()"
                          label='key'>
                    </v-select>
                </div>
            </div>
            <div class="calendar-container">
                <div class="calendar">
                    <div class="month">
                        <div class="calendar-header">
                            <!-- <h1>Ianuarie</h1>
                            <h1>2019</h1> -->
                        </div>
                        <div class="day" :class="{'current': day.name == filters.day}" v-for="day in days" :key="day.name" @click="applyQuery({ f_day: day.name })">
                           <span> {{day.name}} </span>
                            <div v-if="day.count>0" class="mandatory-task" v-b-tooltip.hover>
                                {{day.count}}
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="add-user-form">
          <div class="save-contact-buttons col-md-12">
              <button type="button" @click='addNew()'>
                  <i class="fas fa-plus-circle"></i>
                  Adauga
              </button>
          </div>
        </div>
        <div class="hidden-table visibleTable">
        <table class="table app_table">
            <thead>
            <tr class="app_table_header">
                <th scope="col" @click="handleSort('client')"> {{$t('tableHeader.numeClient')}}
                    <!-- <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'client' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'client' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span> -->
                </th>
                <th scope="col" @click="handleSort('client')"> {{$t('tableHeader.numePartener')}}
                    <!-- <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'client' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'client' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span> -->
                </th>
                <th scope="col" @click="handleSort('product')"> {{$t('tableHeader.numeProdus')}}
                    <!-- <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'product' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'product' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span> -->
                </th>
                <th scope="col" @click="handleSort('done_date')"> {{$t('tableHeader.dataRealizata')}}
                    <!-- <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'done_date' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'done_date' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span> -->
                </th>
                <th scope="col" @click="handleSort('start_date')"> {{$t('tableHeader.dataDeRealizare')}}
                    <!-- <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'start_date' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'start_date' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span> -->
                </th>
                <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
            </tr>
            </thead>
            <tbody v-if="vtps">
            <tr v-for="(vtp, index) in activeRecords" :key="index">
                <td :tableheadData="$t('tableHeader.numeClient')"> {{(vtp.client_name) ? vtp.client_name: '-'}}</td>
                <td :tableheadData="$t('tableHeader.numePartener')"> {{(vtp.partner) ? vtp.partner: '-'}}</td>
                <td :tableheadData="$t('tableHeader.numeProdus')"> {{(vtp.product_name) ? vtp.product_name : '-'}}</td>
                <td :tableheadData="$t('tableHeader.dataRealizata')"> {{(vtp.done_date) ? vtp.done_date : '-' }}</td>
                <td :tableheadData="$t('tableHeader.dataDeRealizare')"> {{(vtp.start_date) ? vtp.start_date: '-'}}</td>
                <td :tableheadData="$t('tableHeader.dataDeRealizare')" class="options-case">
                    <router-link :to="{ name: 'viewvtp', params: { id: vtp.id }}" class="view-user"
                                 data-placement="top" data-toggle="tooltip" :title="$t('placeholder.vizualizeaza')">
                        <i class="fas fa-eye"></i>
                    </router-link>
                    <!--<router-link :to="{ name: 'editpartner', params: { id: partner.id }}" class="edit-user"
                                 data-placement="top" data-toggle="tooltip" :title="$t('placeholder.editeaza')">
                        <i class="fas fa-pen"></i>
                    </router-link>
                    <a href="javascript:void(0)" class="delete-user" data-placement="top" data-toggle="tooltip"
                       :title="$t('placeholder.sterge')" @click="removeUser(index, partner.id)">
                        <i class="fas fa-trash-alt"></i>
                    </a>-->
                </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
                <td colspan="8" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                <td colspan="8" v-else>{{$t('errors.emptyResult')}}</td>
            </tr>
            </tbody>
            <tfoot v-if="vtps">
            <tr class="app_table_header">
                <th scope="col">
                    {{$t('tableHeader.numeClient')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.numePartener')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.numeProdus')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.dataRealizata')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.dataDeRealizare')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.optiuni')}}
                </th>
            </tr>
            </tfoot>
        </table>
        <div class="col-lg-12 col-md-12" v-if="vtps">
            <div class="pagination-wrapper">
                <div class="results-message">
                    <p>
                        <i class="fas fa-info-circle"></i>
                        {{$t('pagination.info', { from: this.meta.from, to: this.meta.to, total: this.meta.total })}}
                    </p>
                    <div class="filter-results-number">
                        <label> {{$t('txt.afiseaza')}}: </label>
                        <select v-model="filters.per_page" @change="applyQuery({ per_page: filters.per_page })">
                            <option value="25"> {{$t('txt.rezultatePePagina',{nr:25})}} </option>
                            <option value="50"> {{$t('txt.rezultatePePagina',{nr:50})}} </option>
                            <option value="100"> {{$t('txt.rezultatePePagina',{nr:100})}} </option>
                        </select>
                    </div>
                </div>
                <ul class="pagination-box">
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: 1 })" class="Previous"><i
                                class="fas fa-angle-double-left pag-left"></i></a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page-1 })"
                           class="Previous"><i class="fas fa-angle-left pag-left"></i></a>
                    </li>
                    <li class="pp-dot" v-for="page in pagination"
                        :class="{'pp-dot-active': meta.current_page === page }" :key="page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: page })">{{page}}</a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page+1 })"><i
                                class="fas fa-angle-right pag-right"></i> </a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.last_page })"> <i
                                class="fas fa-angle-double-right pag-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import ServiceService from '../../api-services/service.service.js'
export default {
  name: 'calendar',
  data () {
    return {
      vtps: null,
      meta: null,
      filters: {
        year: null,
        month: null,
        day: null
      },
      calendarTable: false,
      years: [],
      months: [
        { name: 1, key: 'Ianuarie' },
        { name: 2, key: 'Februarie' },
        { name: 3, key: 'Martie' },
        { name: 4, key: 'Aprilie' },
        { name: 5, key: 'Mai' },
        { name: 6, key: 'Iunie' },
        { name: 7, key: 'Iulie' },
        { name: 8, key: 'August' },
        { name: 9, key: 'Septembrie' },
        { name: 10, key: 'Octombrie' },
        { name: 11, key: 'Noiembrie' },
        { name: 12, key: 'Decembrie' }
      ],
      days: [
        { name: 1, count: 0, active: 0 },
        { name: 2, count: 0, active: 0 },
        { name: 3, count: 0, active: 0 },
        { name: 4, count: 0, active: 0 },
        { name: 5, count: 0, active: 0 },
        { name: 6, count: 0, active: 0 },
        { name: 7, count: 0, active: 0 },
        { name: 8, count: 0, active: 0 },
        { name: 9, count: 0, active: 0 },
        { name: 10, count: 0, active: 0 },
        { name: 11, count: 0, active: 0 },
        { name: 12, count: 0, active: 0 },
        { name: 13, count: 0, active: 0 },
        { name: 14, count: 0, active: 0 },
        { name: 15, count: 0, active: 0 },
        { name: 16, count: 0, active: 0 },
        { name: 17, count: 0, active: 0 },
        { name: 18, count: 0, active: 0 },
        { name: 19, count: 0, active: 0 },
        { name: 20, count: 0, active: 0 },
        { name: 21, count: 0, active: 0 },
        { name: 22, count: 0, active: 0 },
        { name: 23, count: 0, active: 0 },
        { name: 24, count: 0, active: 0 },
        { name: 25, count: 0, active: 0 },
        { name: 26, count: 0, active: 0 },
        { name: 27, count: 0, active: 0 },
        { name: 28, count: 0, active: 0 },
        { name: 29, count: 0, active: 0 },
        { name: 30, count: 0, active: 0 },
        { name: 31, count: 0, active: 0 }
      ]
    }
  },
  methods: {
    addNew () {
      let year = this.filters.year.name
      let month = this.filters.month.name
      let day = this.filters.day ? this.filters.day : 1
      this.$router.push('/service/works?date=' + year + '-' + month + '-' + day)
    },
    filterCalendar () {
      if (this.filters.year && this.filters.month) {
        this.applyQuery({ f_year: this.filters.year.name, f_month: this.filters.month.name })
      } else if (this.filters.year) {
        // let newRouteQuery = _.omit(this.$route.query, 'f_month')
        // this.$router.replace( { query: newRouteQuery } )
        this.filters.month = this.months.find(month => month.name === '1')
        this.applyQuery({ f_year: this.filters.year, f_month: this.filters.month })
      } else {
        let date = new Date()
        this.filters.year = this.years.find(month => month.name === date.getFullYear())
        this.filters.month = this.months.find(month => month.name === '1')
        this.applyQuery({ f_year: this.filters.year, f_month: this.filters.month })
      }
      this.showFilters = false
    },
    applyQuery (params) {
      let resetPage = { page: '1' }
      let currentQuery = this.$route.query
      if (params.q) {
        this.searchBy = this.search
      }
      // params = _.pickBy(params)
      // merge 3 objects
      let query = { ...currentQuery, ...resetPage, ...params }
      this.$router.push({ name: 'calendar', query: query })
    },
    getCalendar () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('showLoading')
        ServiceService.getAll()
          .then((response) => {
          // clear calendar
            for (let i = 0; i < this.days.length; i++) {
              this.days[i].count = 0
            }
            if (response.data.data.length > 0) {
              this.vtps = response.data.data
              if (!(this.filters.month && this.filters.year)) {
                let date = new Date()
                this.filters.month = this.months.find(month => month.name === date.getMonth() + 1)
                this.filters.year = this.years.find(year => year.name === date.getFullYear())
              }
              for (let i = 0; i < this.vtps.length; i++) {
                let dDate = new Date(this.vtps[i]['start_date'])
                let day = dDate.getDate() - 1
                this.days[day].count = this.days[day].count + 1
                this.$set(this.vtps[i], 'day', day + 1)
              }
              this.meta = response.data.meta
            } else {
              this.vtps = null
            }
            this.meta = response.data.meta
            this.$store.dispatch('hideLoading')
            resolve(response)
          })
          .catch((error) => {
            let message = error.response.data.error
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: message,
              'animation-type': 'css'
            })
            this.$store.dispatch('hideLoading')
            reject(error)
          })
      })
    },
    setYears () {
      return new Promise((resolve, reject) => {
        let dDate = new Date()
        let year = dDate.getFullYear()
        for (let i = 0; i <= 5; i++) {
          let data = { name: year - 1 + i }
          this.years.push(data)
        }
        resolve('OK')
      })
    },
    setParams () {
      let query = this.$route.query
      let date = new Date()
      if (query.f_month) {
        this.filters.month = this.months.find(month => month.name === query.f_month)
      } else {
        this.filters.month = this.months.find(month => month.name === date.getMonth() + 1)
      }
      if (query.f_year) {
        this.filters.year = this.years.find(year => year.name === parseInt(query.f_year))
      } else {
        this.filters.year = this.years.find(year => year.name === date.getFullYear())
      }
      if (query.f_day) {
        this.filters.day = parseInt(query.f_day)
        this.days[parseInt(query.f_day) - 1].active = 1
      }
    }
  },
  watch: {
    search: function (value) {
      if (!value) {
        this.applyQuery({ q: value })
      }
    },
    '$route.query' () {
      let query = this.$route.query
      let date = new Date()
      if (query.f_month) {
        this.filters.month = this.months.find(month => month.name === query.f_month)
      } else {
        this.filters.month = this.months.find(month => month.name === date.getMonth() + 1)
      }
      if (query.f_year) {
        this.filters.year = this.years.find(year => year.name === parseInt(query.f_year))
      } else {
        this.filters.year = this.years.find(year => year.name === date.getFullYear())
      }
      if (query.f_day) {
        this.filters.day = parseInt(query.f_day)
        this.days[parseInt(query.f_day) - 1].active = 1
      }
      this.getCalendar()
      this.$store.dispatch('hideLoading')
    }
  },
  computed: {
    start_page () {
      if (this.meta.last_page > 5 && this.meta.current_page > 2) {
        return parseInt(this.meta.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page () {
      if (this.meta.last_page > 5 && this.meta.current_page + 2 < this.meta.last_page) {
        return parseInt(this.meta.current_page, 10) + 2
      } else {
        return this.meta.last_page
      }
    },
    // return only 5 pages for pagination
    pagination () {
      let pages = []
      for (let i = this.start_page; i <= this.stop_page; i++) {
        pages.push(i)
      }
      return pages
    },
    activeRecords: function () {
      let vm = this
      if (vm.filters.day) {
        let output = this.vtps.filter(function (u) {
          if (u.day === vm.filters.day) {
            return u
          }
        })
        return output
      } else {
        return this.vtps
      }
    }
  },
  async created () {
    await this.setYears()
    await this.setParams()
    await this.getCalendar()
    this.$store.dispatch('hideLoading')
  }
}
</script>
